export type Environment = "dev" | "dev2" | "staging" | "prod";

export const DEFAULT_TENANT_NAME = "default";

export type Tenant = {
  environment: Environment;
  tenantName: string;
};
